var Transitions;
(function (Transitions) {
  Transitions["FadeIn"] = 'fade-in';
  Transitions["FadeInSlide"] = 'fade-in-slide';
})(Transitions || (Transitions = {}));
export { Transitions };